import { render, staticRenderFns } from "./GroepsInstellingen.vue?vue&type=template&id=01685b2c&"
import script from "./GroepsInstellingen.vue?vue&type=script&lang=js&"
export * from "./GroepsInstellingen.vue?vue&type=script&lang=js&"
import style0 from "./GroepsInstellingen.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports